/**
 * Add user dialog
 * 
 * @author JHO 
 * Last changed: 11.08.2021
 * Changes: initial implementation
 */

import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import AddUserForm from './AddUserForm';

const AddUserDialog = (props) => {
  return (
    <Dialog open={props.open} onClose={props.handleClose}>
      <AddUserForm handleClose={props.handleClose} sites={props.sites} handleSuccess={props.handleSuccess} handleError={props.handleError} token={props.token}/>
    </Dialog>
  );
};

export default AddUserDialog;